import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

const Link = ({ children, to, margin, fieldWidth, ...rest }) => {
  return (
    <GatsbyLink
      getProps={({ isPartiallyCurrent, isCurrent }) => {
        return {
          style: {
            textDecoration: 'none',
            margin: '0 5px',
            display: 'flex',
            alignItems: 'center',
          },
          className:
            isCurrent || (isPartiallyCurrent && to !== 'app') ? 'active' : '',
        }
      }}
      to={to}
      activeClassName="active"
      {...rest}
    >
      {children}
    </GatsbyLink>
  )
}

export default Link
